import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { createInformationsKeys } from '../queries/useInformations';
import useFilterForQuery from '../hooks/useFilterForQuery';
import { useDispatch } from 'react-redux';
import { setSelectedInfo } from '../store/actions';

const deleteInfo = async (infoId) => {
  const data = await request.delete(
    `/Information/${infoId}`,
    {},
    'Не удалось удалить информирование',
    'Error'
  );

  return data;
};

const useDeleteInfo = () => {
  const queryClient = useQueryClient();
  const queryParams = useFilterForQuery();
  const dispatch = useDispatch();

  const deleteInfoMutation = useMutation(({ infoId }) => deleteInfo(infoId), {
    onSuccess: (data, { infoId }) => {
      if (data?.result === 'Ok') {
        queryClient.setQueryData(
          createInformationsKeys(queryParams),
          (oldData) => oldData.filter((oldInfo) => oldInfo.id !== infoId)
        );

        dispatch(setSelectedInfo(null));
      }
    },
  });

  const deleteMutateAsync = (infoId) =>
    deleteInfoMutation.mutateAsync({ infoId });

  return {
    deleteInfo: deleteMutateAsync,
  };
};

export default useDeleteInfo;
